import { createContext } from 'react';

import { Shop, User } from 'types';

export type PayoutOrdersContextProps = {
  shops?: Shop[];
  traders?: User[];
  merchants?: User[];
  /**
   * Orders picked in the manual queue. Shared across the section's tabs so the operations
   * journal can hand its unprocessed orders back to the queue for another attempt.
   */
  manualSelectedIds?: string[];
  setManualSelectedIds?: (ids: string[]) => void;
};

export const PayoutOrdersContext = createContext<PayoutOrdersContextProps>({
  shops: [],
  traders: [],
  merchants: [],
  manualSelectedIds: [],
});
